<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "Noto Sans SC PostScript";
  src: url("./assets/fonts/noto-sans-sc/NotoSansSC-Regular.subset.woff2") format("woff2");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

:root {
  --app-font-family: "Noto Sans SC PostScript", "Noto Sans SC", Avenir, Helvetica, Arial, sans-serif;
}

html {
  scroll-behavior: smooth;
  font-family: var(--app-font-family);
}

body {
  margin: 0;
  background: #f2f5f7;
  font-family: var(--app-font-family);
}

body,
body button,
body input,
body textarea,
body select,
body option {
  font-family: var(--app-font-family);
}

a,
button,
input,
textarea,
select {
  font: inherit;
}

#app {
  font-family: var(--app-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #16222d;
}
</style>



// WEBPACK FOOTER //
// src/App.vue